// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31RVb","top":"styles_top__3Y-h8"};